import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

// Public pages
import Login from "./pages/Login";
import Signup from "./pages/Signup";

// 🔓 Public embed page (chat widget)
import Embed from "./pages/Embed";

// Setup / Admin
import SetupWizard from "./pages/SetupWizard";
import Tenants from "./pages/Tenants";
import SetupPhoneNumbers from "./pages/SetupPhoneNumbers";

// Your existing protected pages
import Dashboard from "./pages/Dashboard";
import History from "./pages/History";
import PredefinedMessages from "./pages/PredefinedMessages";
import SettingsPage from "./pages/Settings";
import BlockedNumbers from "./pages/BlockedNumbers/BlockedNumbers";
import VoiceResponses from "./pages/VoiceResponses";
import AudioTranscriptions from "./pages/AudioTranscriptions";
import UrgentAlerts from "./pages/UrgentAlerts";
import CaseTypes from "./pages/CaseTypes";
import Scheduler from "./pages/Scheduler";
import Users from "./pages/Users";
import Reports from "./pages/Reports";
import Logs from "./pages/Logs";
import Feedback from "./pages/Feedback";
import Notes from "./pages/Notes";
import Realtime from "./pages/Realtime";
import Filters from "./pages/Filters";
import Clients from "./pages/Clients";
import AwaitingHuman from "./pages/AwaitingHuman";
import AlertRecipients from "./pages/AlertRecipients";
import InformativePanel from "./pages/InformativePanel";
import Billing from "./pages/Billing";

function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <Layout>
        <Outlet />
      </Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* 🔓 Public embed route (used by the website widget iframe) */}
        <Route path="/embed" element={<Embed />} />

        {/* Protected area */}
        <Route element={<ProtectedLayout />}>
          {/* MAIN */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/history" element={<History />} />
          <Route path="/awaiting" element={<AwaitingHuman />} />

          {/* CLIENT INTERACTION */}
          <Route path="/predefined" element={<PredefinedMessages />} />
          <Route path="/voice" element={<VoiceResponses />} />
          <Route path="/transcriptions" element={<AudioTranscriptions />} />

          {/* MANAGEMENT */}
          <Route path="/alerts" element={<UrgentAlerts />} />
          <Route path="/cases" element={<CaseTypes />} />
          <Route path="/scheduler" element={<Scheduler />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/alert-recipients" element={<AlertRecipients />} />

          {/* ANALYTICS */}
          <Route path="/users" element={<Users />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/billing" element={<Billing />} />

          {/* MODERATION */}
          <Route path="/notes" element={<Notes />} />
          <Route path="/realtime" element={<Realtime />} />
          <Route path="/filters" element={<Filters />} />
          <Route path="/blocked" element={<BlockedNumbers />} />

          {/* SETTINGS */}
          <Route path="/settings/profile" element={<SettingsPage />} />

          {/* SETUP */}
          <Route path="/setup" element={<SetupWizard />} />
          <Route path="/setup/informative" element={<InformativePanel />} />
          <Route path="/setup/phone-numbers" element={<SetupPhoneNumbers />} />

          {/* ADMIN / TWILIO */}
          <Route path="/tenants" element={<Tenants />} />

          {/* Default protected redirect */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}
